import Select from 'react-select'
import { useTranslation } from 'react-i18next'

type Props = Readonly<{
  sorts: readonly string[]
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}>

const SortSelect = ({ sorts, value, onChange, disabled }: Props) => {
  const { t } = useTranslation()
  const options = sorts.map(sort => ({
    value: sort,
    label: t(`collections.view.layout.${sort}`),
  }))

  return <Select
    options={ options }
    onChange={ (option) => onChange(option?.value ?? sorts[0]) }
    value={ options.find(option => option.value === value) }
    placeholder={ t('defaults.sort') }
    isClearable={ false }
    isDisabled={ disabled }
    styles={ { menu: (styles) => ({ ...styles, zIndex: 210 }) } }
  />
}

export { SortSelect }
